import RouteView from '@/router/RouteView.vue';
import FactorCampus from './index.vue';
import Bill from '../Bill/index.vue';

export default [
  {
    path: '/factorCampus',
    name: 'factorCampus',
    component: RouteView,
    redirect: '/factorCampus/list',
    meta: {
      title: '代理商中心',
    },
    children: [
      {
        path: '/factorCampus/list',
        name: 'FactorCampusList',
        component: FactorCampus,
        meta: {
          title: '代理校区',
        },
      },
      {
        path: '/factorCampus/bill/:id',
        name: 'Bill2',
        component: Bill,
        meta: {
          title: '校区账单',
        },
      },
    ],
  },
];




// WEBPACK FOOTER //
// ./src/views/FactorCampus/index.js